import React, { Component } from 'react';
import { Segment, Dropdown, Label, Form } from 'semantic-ui-react';

class Quarter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quarterOptions: [],
        };
    }

    componentDidMount() {
        fetch(`api/Application/GetQuarters?ratingPeriod=${this.props.ratingPeriod}`)
            .then((response) => response.json())
            .then(data => {
                this.setState({ quarterOptions: data });
            });
    }

    render() {
        const { quarterOptions } = this.state;
        const { quarter, readOnly } = this.props;

        return (
            <Segment>
                <Label ribbon color='green' content='Enter the quarter ending in:' />
                <Form as='div'>
                    <Form.Group>
                        <Form.Field>
                            <label>Quarter</label>
                            <Dropdown
                                name='quarter'
                                placeholder='Quarter'
                                selection
                                options={quarterOptions}
                                onChange={this.props.onQuarterChange}
                                value={quarter}
                                disabled={readOnly}
                            />
                        </Form.Field>
                    </Form.Group>
                </Form>
            </Segment>
        );
    }

}

export default Quarter;